import { Modal, ScrollArea } from "@devhop/ui";
import {
  formatDateLocal,
  formatDateTimeLocal,
} from "@/shared/lib/date-time";
import type { PositionAssignmentDTO } from "@/modules/assign-position/domain/contracts";
import { useUserHistoryQuery } from "../api/queries";

type AssignmentHistoryModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  userId: string;
  userName: string;
};

export function AssignmentHistoryModal({
  open,
  onOpenChange,
  userId,
  userName,
}: AssignmentHistoryModalProps) {
  const history = useUserHistoryQuery(userId);

  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      title={`ປະຫວັດການປ່ຽນຕໍາແໜ່ງ: ${userName}`}
      size="lg"
    >
      <ScrollArea className="max-h-[500px] pr-4">
        {history.isLoading ? (
          <div className="flex items-center justify-center p-8">
            <span className="text-muted-foreground">ກໍາລັງໂຫຼດ...</span>
          </div>
        ) : history.data && history.data.length > 0 ? (
          <div className="space-y-4">
            {history.data.map(
              (assignment: PositionAssignmentDTO, index: number) => (
                <div
                  key={assignment.id}
                  className="border-border border-b pb-4 last:border-b-0 last:pb-0"
                >
                  <div className="flex items-start justify-between gap-4">
                    <div className="flex-1">
                      <div className="font-medium text-sm">
                        {assignment.positionTitle || "ບໍ່ມີຕໍາແໜ່ງ"}
                      </div>
                      {assignment.departmentName && (
                        <div className="mt-1 text-muted-foreground text-xs">
                          {assignment.departmentName}
                        </div>
                      )}
                      <div className="mt-2 text-muted-foreground text-xs">
                        ເລີ່ມ:{" "}
                        {formatDateLocal(assignment.startDate)}
                        {assignment.endDate &&
                          ` - ສິ້ນສຸດ: ${formatDateLocal(assignment.endDate)}`}
                        {!assignment.endDate && " (ປັດຈຸບັນ)"}
                      </div>
                      {assignment.notes && (
                        <div className="mt-1 text-muted-foreground text-xs">
                          ໝາຍເຫດ: {assignment.notes}
                        </div>
                      )}
                    </div>
                    {index > 0 && (
                      <div className="text-muted-foreground text-xs">
                        {formatDateTimeLocal(assignment.createdAt)}
                      </div>
                    )}
                  </div>
                </div>
              ),
            )}
          </div>
        ) : (
          <div className="flex items-center justify-center p-8">
            <span className="text-muted-foreground">ບໍ່ມີປະຫວັດການປ່ຽນຕໍາແໜ່ງ</span>
          </div>
        )}
      </ScrollArea>
    </Modal>
  );
}
